import React from "react";
import Container from "../../../../components/Layout/Container";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import { DEFAULT_PER_PAGE } from "../../../../helpers/default";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import FilterMenu from "../../../../components/Layout/FilterMenu";
import Axios from "axios";
import {
  ButtonSecondary,
  Pagination,
  SelectInput,
  TextInput,
} from "../../../../components/globals";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import {
  ButtonDelete,
  ButtonSmall,
  ButtonEditRow,
} from "../../../../components/common/Buttons";
import { IconSearch, IconHistory } from "../../../../components/Layout/Icons";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import { Checkbox, Tabs, Modal } from "antd";
import { useModal } from "../../../../hooks";
import { InputSwitchComponent } from "../../../../components/globals";
import { IconBanners } from "../../../../components/Layout/Icons";
import { getDateFormat } from "../../../../helpers/Utils";
import RangePickerComp from "../../../../components/common/RangePickerComp";
import { SelectForm } from "../../../../components/common/Buttons";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SwitchComp from "../../../../components/common/SwitchComp";
import ModalNewRuningLineBanner from "./modals/ModalNewRuningLineBanner";
import { useQuery } from "react-query";
import axios from "axios";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import ImageWithPreviewModal from "./modals/ImageWithPreviewModal";
import MarketingFeatureTabUi from "./MarketingFeatureTabUi";
import ContentValidation from "../../../../components/common/ContentValidation";

dayjs.extend(isBetween);

const { confirm } = Modal;

const RunningLine = ({ tabId, setTabId, onSupplierNameChange }) => {
  const [page, setPage] = React.useState(1);
  const [totals, setTotals] = React.useState(0);
  const [perPage, setPerPage] = React.useState(DEFAULT_PER_PAGE);
  const [filterTitle, setFilterTitle] = React.useState("");
  const [filterDatePeriod, setFilterDatePeriod] = React.useState([]);
  const [filterCustomEvent, setFilterCustomEvent] = React.useState("");
  const [filterSelectedShop, setFilterSelectedShop] = React.useState("");
  const [filterStatus, setFilterStatus] = React.useState("");
  const { modalOpt, setModalOpt, closeModal } = useModal();

  const fetchOrderShops = async () => {
    const response = await axios.get("/api/v1/order_shops");
    return response.data;
  };

  const { data: orderShops } = useQuery("orderShops", fetchOrderShops);
  const ALLOWED_SHOPS = ["BB LT", "BB LV", "BB EE", "BB FI", "TR LT"];
  const allShops = orderShops?.shops || [];
  const shops = allShops.filter(s => ALLOWED_SHOPS.includes(s.label));

  const fetchBanners = async () => {
    let url = `/api/v1/banners?page=${page}&per_page=${perPage}&q[banner_place_eq]=running_line`;
    if (filterTitle) {
      url += `&q[title_i_cont]=${filterTitle}`;
    }
    if (filterCustomEvent) {
      url += `&q[custom_event_i_cont]=${filterCustomEvent}`;
    }
    if (filterDatePeriod?.length) {
      url += `&q[valid_to_gteq]=${filterDatePeriod[0]}&q[valid_from_lteq]=${filterDatePeriod[1]}`;
    }
    if (filterSelectedShop) {
      url += `&q[banner_shops_order_shop_id_eq]=${filterSelectedShop}`;
    }
    if (filterStatus) {
      url += `&q[banner_shops_active_true]=${filterStatus}`;
    }
    const response = await axios.get(url);
    return response.data;
  };

  const {
    data: banners,
    isLoading: bannersLoading,
    error: bannersError,
    refetch: refetchBanners,
  } = useQuery("banners", fetchBanners);

  const deleteBannerMutation = useMutation(
    (id) => axios.delete(`/api/v1/banners/${id}`),
    {
      onSuccess: () => {
        antdAsyncMessageSuccess({
          text: "Successfully deleted",
          key: "delete_banner",
        });
        refetchBanners();
      },
      onError: () => {
        antdAsyncMessageError({
          text: "Error occurred",
          key: "delete_banner",
        });
      },
    }
  );

  const switchStatusMutation = useMutation({
    mutationFn: (value) => {
      console.log(value);
      const formData = new FormData();
      formData.append("banner[banner_shops_attributes][0][id]", value.shopId);
      formData.append(
        "banner[banner_shops_attributes][0][active]",
        value.active
      );

      return axios.put(`/api/v1/banners/${value.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      antdAsyncMessageSuccess({
        text: "Successfully updated",
        key: "update_banner",
      });
      refetchBanners();
    },
    onError: () => {
      antdAsyncMessageError({
        text: "Error occurred",
        key: "update_banner_error",
      });
    },
  });

  const handleFilterChange = () => {
    refetchBanners();
  };

  const handleFilterClear = () => {
    setFilterCustomEvent("");
    setFilterTitle("");
    setFilterDatePeriod([]);
    setFilterStatus("");
    setFilterSelectedShop("");
  };

  React.useEffect(() => {
    if (banners?.totals) {
      setTotals(banners?.totals);
    }
  }, [banners]);

  React.useEffect(() => {
    refetchBanners();
  }, [page, perPage]);

  React.useEffect(() => {
    refetchBanners();
  }, [modalOpt]);

  return (
    <>
      <ContentBlock>
        <FilterMenu
          length={banners?.totals}
          text2={`Banners`}
          iconComponent={<IconBanners />}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
          totals={banners?.data?.totals}
        />
      </ContentBlock>
      <div className="col-12">
        <MarketingFeatureTabUi tabId={tabId} setTabId={setTabId} />
      </div>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => {
            handleFilterChange();
          }}
          add={false}
          clearFilter={() => handleFilterClear()}
          button1={
            <>
              <div className="float-left ml-2" style={{ width: 104 }}>
                <ButtonSecondary
                  onClick={() => setModalOpt("new_running_line", 0)}
                >
                  New line
                </ButtonSecondary>
              </div>
            </>
          }
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              <>
                <div className="px-1">
                  <TextInput
                    text="Title"
                    name="Title"
                    style={{ width: 165 }}
                    value={filterTitle}
                    onChange={(val) => {
                      setFilterTitle(val.target.value);
                    }}
                  />
                </div>
                <div className="px-1">
                  <RangePickerComp
                    style={{ width: "250px" }}
                    label="Date period"
                    showTime={{ format: "HH:mm" }}
                    placeholder={["Start time", "End time"]}
                    value={
                      filterDatePeriod
                        ? [
                          getDateFormat(filterDatePeriod[0]),
                          getDateFormat(filterDatePeriod[1]),
                        ]
                        : ["", ""]
                    }
                    onChange={(_, value) => {
                      setFilterDatePeriod(value);
                    }}
                    disabledDate={() => false}
                  />
                </div>
                <div className="px-1">
                  <SelectForm
                    placeholder="Shop"
                    options={[{ value: null, label: " " }, ...shops]}
                    selector="shop"
                    style={{ width: 165 }}
                    value={filterSelectedShop}
                    onChange={(shop) => setFilterSelectedShop(shop)}
                  />
                </div>
                <div className="px-1">
                  <InputSwitchComponent
                    label="Status"
                    name="auto_type"
                    options={[
                      {
                        label: "All",
                        value: "",
                      },
                      {
                        label: "Enabled",
                        value: "true",
                      },
                      {
                        label: "Disabled",
                        value: "false",
                      },
                    ]}
                    value={filterStatus}
                    onChange={(val) => {
                      setFilterStatus(val.target.value);
                    }}
                  />
                </div>
              </>
            </div>
          </div>
        </TableFilterBox>
        <div>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <ContentValidation
              loader={bannersLoading}
              array={banners?.data}
              error={bannersError}
            >
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Title</th>
                    <th className="text-black">Type</th>
                    <th className="text-black">Valide period</th>
                    <th className="text-black">Custom event</th>
                    <th className="text-black">Shop</th>
                    <th className="text-black">Status</th>
                    <th className="text-black"></th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {banners?.data?.map?.((item) => (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle capitalize-first-letter">
                        {item?.background_type}
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              marginRight: 5,
                              borderRadius: 100,
                              backgroundColor: dayjs().isBetween(
                                dayjs(item?.valid_from),
                                dayjs(item?.valid_to)
                              )
                                ? "#28A745"
                                : "#C94747",
                            }}
                          />
                          {`${dayjs(item?.valid_from).format(
                            "YYYY-MM-DD HH:mm"
                          )} - ${dayjs(item?.valid_to).format(
                            "YYYY-MM-DD HH:mm"
                          )}`}
                        </div>
                      </td>
                      <td className="align-middle">{item?.custom_event}</td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop, index) => (
                          <div
                            key={"shop.order_shop.title" + index}
                            className="d-flex justify-content-center align-items-center grey-tabblet"
                          >
                            <p className="mb-0 mt-0">{shop.order_shop.title}</p>
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop) => (
                          <div className="d-flex align-items-center switch-container">
                            <SwitchComp
                              className=""
                              checked={shop.active}
                              onChange={() =>
                                switchStatusMutation.mutate({
                                  id: item?.id,
                                  shopId: shop?.id,
                                  active: !shop.active,
                                })
                              }
                            />
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        {item?.background_type === "text" ? (
                          <>
                            {item?.banner_shops?.map?.((shop, index) => (
                              <p key={"item?.banner_shops" + index}>
                                {shop.content}
                              </p>
                            ))}
                          </>
                        ) : (
                          <>
                            {item?.banner_shops?.map?.((shop, index) => (
                              <ImageWithPreviewModal
                                key={"shop?.mobile_image" + index}
                                asset={{
                                  url:
                                    shop?.desktop_image ||
                                    "https://via.placeholder.com/150",
                                }}
                                created_at={item?.created_at}
                                id={item?.id}
                                height={30}
                              />
                            ))}
                          </>
                        )}
                      </td>
                      <td className="align-middle">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: 5 }}
                        >
                          <ButtonEditRow
                            className="d-flex justify-content-center align-items-center"
                            onClick={() =>
                              setModalOpt("edit_running_line", item.id)
                            }
                          />
                          <ButtonDelete
                            className="d-flex justify-content-center align-items-center"
                            onDelete={() =>
                              confirm({
                                title: "Are you sure?",
                                icon: (
                                  <ExclamationCircleOutlined className="text-primary" />
                                ),
                                content:
                                  "You will not be able to undo this action",
                                onOk() {
                                  deleteBannerMutation.mutate(item.id);
                                },
                                onCancel() {
                                  console.log("Cancel");
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ContentValidation>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </div>
        {modalOpt.type === "new_running_line" && (
          <ModalNewRuningLineBanner
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
          />
        )}
        {modalOpt.type === "edit_running_line" && (
          <ModalNewRuningLineBanner
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
            bannerData={banners?.data}
          />
        )}
      </ContentBlock>
    </>
  );
};

export default RunningLine;

const TabUi = ({ tabId, setTabId }) => {
  return (
    <Tabs
      className="mx-2 text-base"
      popupClassName="mb-0"
      tabBarStyle={{
        marginBottom: 0,
      }}
      activeKey={tabId}
      defaultActiveKey={tabId}
      items={[
        { label: "Landing banners", key: "landing" },
        { label: "Category banners", key: "category" },
        { label: "Running Line banners", key: "runningLine" },
      ]}
      onChange={(value) => {
        setTabId(value);
      }}
    />
  );
};
